export interface LocaleConfiguration {
  defaultLocale: string;
  supportedLocales: string[];
}

function error(message: string): void {
  throw new Error(`[Locale Service]: ${message}`);
}

class LocaleService {
  private initialized: boolean = false;
  private locale: string = '';
  private supportedLocales: Set<string> = new Set();

  init(configuration: LocaleConfiguration): void {
    if (this.initialized) {
      error('Already initialized');
    }

    const { defaultLocale, supportedLocales } = configuration;

    this.locale = defaultLocale;
    this.supportedLocales = new Set(supportedLocales);

    this.initialized = true;
  }

  changeLocale(locale: string): void {
    if (this.locale === locale) {
      return;
    }

    if (!this.isLocaleSupported(locale)) {
      error(`Locale "${locale}" is not supported by the application.`);
    }

    this.locale = locale;
  }

  getCurrentLocale(): string {
    return this.locale;
  }

  getSupportedLocales(): Set<string> {
    return this.supportedLocales;
  }

  isLocaleSupported(locale: string): boolean {
    return this.getSupportedLocales().has(locale) || locale.length === 0;
  }
}

const instance = new LocaleService();

export default instance;
